import { bootstrapApplication } from '@angular/platform-browser';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

import { App } from './app/app';
import { appConfig } from './app/app.config';

/* Call the element loader before the render call, so the PWA camera/modal
 * fallbacks are available when running in a browser. Mirrors main.tsx. */
defineCustomElements(window);

bootstrapApplication(App, appConfig).catch((err) => {
  // eslint-disable-next-line no-console -- bootstrap failure has nowhere else to go
  console.error(err);
});
